import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';


import Vue from 'vue'

const getDefaultStateForBankAccounts = () => {
    return {
        accounts: [],
        account:{},
        bank_account_id:null,
        is_deleted:-1,
        is_created:null,
        is_updated:null,
        company_bankaccounts:[]
    }
  }
  
const state = getDefaultStateForBankAccounts()

// getters
const getters = {}

// mutations
const mutations = {
    RESET_STATE_FOR_BANKACCOUNTS (state) {
        Object.assign(state, getDefaultStateForBankAccounts())
    },
    FETCH_ALL(state, data){
        state.accounts = data
    },
    FETCH(state, data){
        state.account = data
    },
    SET_BANK_ACCOUNT_ID(state, data){
        state.bank_account_id = data
    },
    SET_IS_DELETED(state, data){
        state.is_deleted = data
    },
    SET_IS_CREATED(state, data){
        state.is_created = data
    },
    SET_IS_UPDATED(state, data){
        state.is_updated = data
    },
    FETCH_COMPANY_BANKACCOUNTS(state, data){
        state.company_bankaccounts = data
    },
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
        commit("RESET_STATE_FOR_BANKACCOUNTS")
    },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_BANK_ACCOUNT'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Bank Account has been created",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })

                  //dispatch("customers/fetch", {"code":data.contact_code}, {root:true})
                  commit("SET_BANK_ACCOUNT_ID", id)
                }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
            }
          })
          .catch((error) => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  alert("Problem Creating Bank Accounts")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['UPDATE_BANK_ACCOUNT'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: "Bank Account has been updated",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                //dispatch("customers/fetch", {"code":data.contact_code}, {root:true})
                // commit("SET_BANK_ACCOUNT_ID", id)
                commit("SET_IS_UPDATED", 1)
            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }

                commit("SET_IS_UPDATED", 0)

            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async delete({ commit, dispatch }, data) {
        console.log(apiRoutes)
        await axios.post(apiRoutes['DELETE_BANK_ACCOUNT'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                  let id  = response.data.data
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Bank Account has been deleted",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  //dispatch("customers/fetch", {"code":data.contact_code}, {root:true})
                 // commit("SET_BANK_ACCOUNT_ID", id)
                 commit("SET_IS_DELETED", 1)
  
              }
              else
              {
                  let errors = response.data.data.errors
  
                  if(Array.isArray(errors))
                  {
                    console.log(errors)
                    let msg = errors.join("\n")
  
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
  
              }
  
            })
            .catch((error) => {
                alert(error)
                // console.log(error.response)
  
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    //console.log("Problem submitting New Post", error);
                    alert("Application Error")
                }
            });
    },
    fetchCompanyAccounts({ commit }, data) {
        return axios.post(apiRoutes['RETRIEVE_BANKACCOUNTS_BY_CURRENCY_CODE'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_COMPANY_BANKACCOUNTS', response.data.data)
              } else {
                commit('FETCH_COMPANY_BANKACCOUNTS', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
